import React, { useState } from 'react';
import { Modal, Form, Input, Button, Switch, Tooltip } from 'antd';

const Model = ({ title, open, onCancel, onFinish, label1,type1,type2, name1, onSwitchChange, placeholder1, message1, label2, name2, placeholder2, message2, switchLabel, switchName, switchMessage }) => {




  const [form] = Form.useForm();
  const [isSwitchChecked, setIsSwitchChecked] = useState(false);


  const handleNumberInputChange = (e) => {
    const { value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, '');
    form.setFieldsValue({ [name2]: numericValue });
  };



  const handleFinish = (values) => {
    form.resetFields(); 
    onFinish(values);
  };

  const handleCancel = () => {
    form.resetFields(); 
    onCancel();
  };

  const handleSwitchChange = (checked) => {
    setIsSwitchChecked(checked);
    if (onSwitchChange) {
      onSwitchChange(checked);
    }
  };

  return (
    <Tooltip title="Changeable fields">
      <Modal title={title} visible={open} footer={null} onCancel={handleCancel}>
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          onFinish={handleFinish}
          autoComplete="off"
        >
          {label1 && (
            <Form.Item
              label={label1}
              name={name1}
              type={type1}
              labelAlign='left'
              rules={[
                {
                  required: true,
                  message: message1,
                },
              ]}
            >
              <Input placeholder={placeholder1} maxLength={100} />
            </Form.Item>
          )}

          {label2 && (
            <Form.Item
              label={label2}
              name={name2}
              labelAlign='left'
              rules={[
                {
                  required: true,
                  message: message2,
                },
              ]}
            >
              <Input placeholder={placeholder2} maxLength={6} onChange={handleNumberInputChange} />
            </Form.Item>
          )}

          {switchLabel && (
            <Form.Item
              label={switchLabel}
              name={switchName}
              type={type2}
              labelAlign='left'
              valuePropName="checked"
              rules={[
                {
                  required: true,
                  validator: (_, value) =>
                    value ? Promise.resolve() : Promise.reject(new Error(switchMessage)),
                },
              ]}
            >
              <Switch onChange={handleSwitchChange}
                className={isSwitchChecked ? '' : 'switch-false bg-[#ccc]'} />
            </Form.Item>
          )}

          <div>
            <Button className='text-white bg-colorAccent rounded-2xl py-1 px-4 block mx-auto' type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </Form>
      </Modal>
    </Tooltip>
  );
};

export default Model;
